import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { ConsentCodePrefixDto } from '@/features/dashboard/consentCodePrefix/types/ConsentCodePrefixDto.ts';

const consentCodePrefixApi = {
  get: async (): Promise<ConsentCodePrefixDto> => {
    return await fetchPrivateApi<ConsentCodePrefixDto>(
      'GET',
      'settings/consent/code-prefix',
    );
  },
  set: async (dto: ConsentCodePrefixDto): Promise<ConsentCodePrefixDto> => {
    return await fetchPrivateApi<ConsentCodePrefixDto>(
      'PUT',
      'settings/consent/code-prefix',
      dto,
    );
  },
};

export default consentCodePrefixApi;
